(ns entities.income.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.income.specs :as sp]
    [util.core :refer [no-nils]]
    )
  )

(def path [:entities :income])

(defn- has-spouse? [m]
  (contains? (:spouse m) :id))

(rf/reg-entity
  :income
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/income)
                :success [:income/fetched]
                :error [:income/fetch-errored]
                :cancellable? true}})

   :patch
   (fn [cfx [{:keys [data]}]]
     (let [to-send (if (has-spouse? data) data (dissoc data :spouse))]
       {:graphql {:gql (qu/update-income {:input to-send})
                  :success [:income/updated]
                  :error [:income/update-errored]}}))

   :spec/patch ::sp/patch
   })

(defn- no-nils [m]
  ;; graphql is awesome and will return {:spouse nil} for some clients
  (into {} (remove (comp nil? second)) m))

(rf/reg-event-db
  :income/fetched
  (rf/path path)
  (fn [_ [data]]
    (no-nils (get-in data [:client :income]))))

(rf/reg-event-db
  :income/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (no-nils (get-in data [:client :income]))))

(rf/reg-event-db
  :income/updated
  (rf/path path)
  (fn [_ [data]]
    (no-nils (:update-income data))))

(rf/reg-event-db
  :income/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (no-nils (:update-income data))))
